import { INIT_CONFIG } from './actions';

const initialState = {

};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case INIT_CONFIG: {

            return {
                ...state,
                data: action.data
            }
        }

        default: {
            return state
        };
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/config/index.js